import Service, { getCallApiFunction } from '../service'

export type FeaturedCategoryResponse = {
  collection: string
  createdAt: string
  highlightText: string
  id: number
  imageUrl: string
  isDel: boolean
  linkUrl: string
  modifiedAt: string
  title: string
}[]

export enum FeaturedCategoryStatus {
  ACTIVE = 100,
  INACTIVE = 0,
}

export type FeaturedCategoryRequest = {
  status?: FeaturedCategoryStatus
}

class FetchFeaturedCategoryListApi extends Service {
  constructor(params?: FeaturedCategoryRequest) {
    super()
    this.name = 'FETCH_FEATURED_CATEGORY_LIST'
    this.config = {
      url: '/v1/product/category/feature',
      method: 'GET',
      params,
    }
  }
}

export const fetchPromoCategoryList = (params?: FeaturedCategoryRequest): Promise<FeaturedCategoryResponse> =>
  getCallApiFunction(new FetchFeaturedCategoryListApi(params))
